import { createI18n } from 'vue-i18n';
import ru from '@/locales/ru.json';
import kz from '@/locales/kz.json';
import en from '@/locales/en.json';
import axios from 'axios';
import lib from '@/lib';

import AuthModel from '@/models/AuthModel.js';

export default class AppModel
{
	/**
	 * Конструктор
	 */
	constructor()
	{
		this.hcaptcha_sitekey = '';
		
		this.langs = ['ru', 'kz'];
		this.langsName = {
			ru: 'Русский',
			kz: 'Қазақша',
			en: 'English',
		};
		this.title = '';
		this.i18n = createI18n({
			legacy: false,
			locale: 'ru',
			messages: { ru, kz, en },
		});
		
		this.auth = new AuthModel();
		
		this.pageTitle = '';
		
		this.examLangs = [
			{
				key: 'ru',
				name: 'Русский',
			},
			{
				key: 'kz',
				name: 'Қазақша',
			},
			{
				key: 'en',
				name: 'English',
			},
		];
		
		this.sel_exam_id = lib.localStorageGet('sel_exam_id')||'';
		this.sel_student_id = lib.localStorageGet('sel_student_id')||'';
	}
	
	/**
	 * Set page title
	 */
	setPageTitle(title)
	{
		this.title = title;
		document.title = title;
	}
	
	/**
	 * Set app lang
	 */
	setLang(lang = 'ru')
	{
		this.i18n.global.locale = lang;
		//this.$root.$i18n.locale = lang
		//axios.defaults.headers.common['Accept-Language'] = lang;
		document.querySelector('html').setAttribute('lang', lang);
		return lang;
	}
	
	/**
	 * Returns lang
	 */
	getLang()
	{
		//return this.i18n.locale;
		return this.i18n.global.locale;
	}
	
	pageReload()
	{
		document.location.reload();
	}
	
	/**
	 * Старт прохождения экзамена студентом
	 * 
	 * @param {*} exam_id		Integer		id экзамена
	 * @param {*} student_id 	Integer		id студента
	 */
	async doStartExam(exam_id, student_id)
	{
		try {
			const response = await axios.post('/api/exams/' + exam_id + '/students/' + student_id + '/start', {}, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			if(response.data.success){
				this.sel_exam_id = exam_id;
				lib.localStorageSet('sel_exam_id', exam_id);
				this.sel_student_id = student_id;
				lib.localStorageSet('sel_student_id', student_id);
			}
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Завершение прохождения экзамена студентом
	 * 
	 * @param {*} exam_id		Integer		id экзамена
	 * @param {*} student_id 	Integer		id студента
	 */
	async doFinishExam(exam_id, student_id)
	{
		try {
			const response = await axios.post('/api/exams/' + exam_id + '/students/' + student_id + '/finish', {}, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			if(response.data.success){
				this.sel_exam_id = '';
				lib.localStorageRemove('sel_exam_id');
				this.sel_student_id = '';
				lib.localStorageRemove('sel_student_id');
			}
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Экзамен запущен или нет
	 */
	isExamStarted()
	{
		return this.sel_exam_id && this.sel_student_id;
	}
	
	/**
	 * Изменение пароля администратора
	 */
	async doChangeAdminPassword(password)
	{
		try {
			const response = await axios.post('/api/settings/change-admin-password', {
				password
			}, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Изменение пароля редактора
	 */
	async doChangeEditorPassword(password)
	{
		try {
			const response = await axios.post('/api/settings/change-editor-password', {
				password
			}, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Изменение пароля экзамена
	 */
	async doChangeExamPassword(password)
	{
		try {
			const response = await axios.post('/api/settings/change-exam-password', {
				password
			}, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка экзаменов
	 */
	async doGetExams(params = {})
	{
		params['lang'] = this.getLang();
		
		try {
			const response = await axios.get('/api/exams', {
				params,
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка экзаменов в архиве
	 */
	async doGetExamsArchive(params = {})
	{
		params['lang'] = this.getLang();
		
		try {
			const response = await axios.get('/api/exams-archive', {
				params,
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка активных экзаменов на текущую дату
	 */
	async doGetExamsToday(params = {})
	{
		params['lang'] = this.getLang();
		
		try {
			const response = await axios.get('/api/exams-today', {
				params,
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение данных о экзамене по его id
	 */
	async doGetExam(exam_id)
	{
		try {
			const response = await axios.get('/api/exams/' + exam_id, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Добавление экзамена
	 */
	async doAddExam(params = {})
	{
		try {
			const response = await axios.post('/api/exams', params, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Изменение данных экзамена по его id
	 */
	async doEditExam(exam_id, params = {})
	{
		try {
			const response = await axios.post('/api/exams/' + exam_id, params, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Перемещение экзамена в архив по его id
	 */
	async doMoveExamToArchive(exam_id)
	{
		try {
			const response = await axios.post('/api/exams/' + exam_id + '/move-to-archive', {}, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Перемещение экзаменов в архив по их id
	 */
	async doMoveExamsToArchive(exams_id)
	{
		try {
			const response = await axios.post('/api/exams/multi/move-to-archive', {
				ids: exams_id,
			}, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Извлечение экзамена из архива по его id
	 */
	async doMoveExamFromArchive(exam_id)
	{
		try {
			const response = await axios.post('/api/exams/' + exam_id + '/move-from-archive', {}, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Извлечение экзаменов из архива по их id
	 */
	async doMoveExamsFromArchive(exams_id)
	{
		try {
			const response = await axios.post('/api/exams/multi/move-from-archive', {
				ids: exams_id,
			}, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление экзамена по его id
	 */
	async doDeleteExam(exam_id)
	{
		try {
			const response = await axios.delete('/api/exams/' + exam_id, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление экзаменов по их id
	 */
	async doDeleteExams(exams_id)
	{
		try {
			const response = await axios.delete('/api/exams/multi', {
				data: {
					ids: exams_id,
				},
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка студентов экзамена по её id
	 */
	async doGetExamStudents(exam_id, params = {})
	{
		params['lang'] = this.getLang();
		
		try {
			const response = await axios.get('/api/exams/' + exam_id + '/students', {
				params,
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение данных о студенте экзамена по его id
	 */
	async doGetExamStudent(exam_id, student_id)
	{
		try {
			const response = await axios.get('/api/exams/' + exam_id + '/students/' + student_id, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение экзаменационных вопросов студента
	 */
	async doGetExamStudentQuestions(exam_id, student_id)
	{
		try {
			const response = await axios.get('/api/exams/' + exam_id + '/students/' + student_id + '/questions', {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Отправка ответа на экзаменационный вопрос студента
	 */
	async doSetExamStudentQuestionAnswer(exam_id, student_id, question_id, answer_id)
	{
		try {
			const response = await axios.post('/api/exams/' + exam_id + '/students/' + student_id + '/questions/' + question_id + '/answer/' + answer_id, {}, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Добавление студента в экзамен
	 */
	async doAddExamStudent(exam_id, params = {})
	{
		try {
			const response = await axios.post('/api/exams/' + exam_id + '/students', params, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Добавление студентов из группы студентов в экзамен
	 */
	async doAddExamStudentsGroup(exam_id, params = {})
	{
		try {
			const response = await axios.post('/api/exams/' + exam_id + '/students/group', params, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Изменение данных студента экзамена по его id
	 */
	async doEditExamStudent(exam_id, student_id, params = {})
	{
		try {
			const response = await axios.post('/api/exams/' + exam_id + '/students/' + student_id, params, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление студента экзамена по его id
	 */
	async doDeleteExamStudent(exam_id, student_id)
	{
		try {
			const response = await axios.delete('/api/exams/' + exam_id + '/students/' + student_id, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка специальностей
	 */
	async doGetSpecialities(params = {})
	{
		params['lang'] = this.getLang();
		
		try {
			const response = await axios.get('/api/specialities', {
				params,
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка специальностей по языку
	 */
	async doGetSpecialitiesByLang(lang, params = {})
	{
		params['lang'] = this.getLang();
		
		try {
			const response = await axios.get('/api/specialities-by-lang/' + lang, {
				params,
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение данных о специальности по ее id
	 */
	async doGetSpeciality(speciality_id)
	{
		try {
			const response = await axios.get('/api/specialities/' + speciality_id, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Добавление специальности
	 */
	async doAddSpeciality(params = {})
	{
		try {
			const response = await axios.post('/api/specialities', params, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Изменение данных специальности по ее id
	 */
	async doEditSpeciality(speciality_id, params = {})
	{
		try {
			const response = await axios.post('/api/specialities/' + speciality_id, params, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление специальности по ее id
	 */
	async doDeleteSpeciality(speciality_id)
	{
		try {
			const response = await axios.delete('/api/specialities/' + speciality_id, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка квалификаций
	 */
	async doGetQualifications(speciality_id, params = {})
	{
		params['lang'] = this.getLang();
		
		try {
			const response = await axios.get('/api/specialities/' + speciality_id + '/qualifications', {
				params,
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение данных о квалификации по ее id
	 */
	async doGetQualification(speciality_id, qualification_id)
	{
		try {
			const response = await axios.get('/api/specialities/' + speciality_id + '/qualifications/' + qualification_id, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Добавление квалификации
	 */
	async doAddQualification(speciality_id, params = {})
	{
		try {
			const response = await axios.post('/api/specialities/' + speciality_id + '/qualifications', params, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Изменение данных квалификации по ее id
	 */
	async doEditQualification(speciality_id, qualification_id, params = {})
	{
		try {
			const response = await axios.post('/api/specialities/' + speciality_id + '/qualifications/' + qualification_id, params, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление квалификации по ее id
	 */
	async doDeleteQualification(speciality_id, qualification_id)
	{
		try {
			const response = await axios.delete('/api/specialities/' + speciality_id + '/qualifications/' + qualification_id, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка дисциплин
	 */
	async doGetDisciplines(params = {})
	{
		params['lang'] = this.getLang();
		
		try {
			const response = await axios.get('/api/disciplines', {
				params,
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка дисциплин по языку
	 */
	async doGetDisciplinesByLang(lang, params = {})
	{
		params['lang'] = this.getLang();
		
		try {
			const response = await axios.get('/api/disciplines-by-lang/' + lang, {
				params,
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение данных о дисциплине по ее id
	 */
	async doGetDiscipline(discipline_id)
	{
		try {
			const response = await axios.get('/api/disciplines/' + discipline_id, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Добавление дисциплины
	 */
	async doAddDiscipline(params = {})
	{
		try {
			const response = await axios.post('/api/disciplines', params, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Изменение данных дисциплины по ее id
	 */
	async doEditDiscipline(discipline_id, params = {})
	{
		try {
			const response = await axios.post('/api/disciplines/' + discipline_id, params, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление дисциплины по ее id
	 */
	async doDeleteDiscipline(discipline_id)
	{
		try {
			const response = await axios.delete('/api/disciplines/' + discipline_id, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка вопросов
	 */
	async doGetQuestions(discipline_id, params = {})
	{
		params['lang'] = this.getLang();
		
		try {
			const response = await axios.get('/api/disciplines/' + discipline_id + '/questions', {
				params,
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение данных о вопросе по его id
	 */
	async doGetQuestion(discipline_id, question_id)
	{
		try {
			const response = await axios.get('/api/disciplines/' + discipline_id + '/questions/' + question_id, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Добавление вопроса
	 */
	async doAddQuestion(discipline_id, params = {})
	{
		try {
			const response = await axios.post('/api/disciplines/' + discipline_id + '/questions', params, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Изменение данных вопроса по его id
	 */
	async doEditQuestion(discipline_id, question_id, params = {})
	{
		try {
			const response = await axios.post('/api/disciplines/' + discipline_id + '/questions/' + question_id, params, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление вопроса по его id
	 */
	async doDeleteQuestion(discipline_id, question_id)
	{
		try {
			const response = await axios.delete('/api/disciplines/' + discipline_id + '/questions/' + question_id, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка учебных заведений
	 */
	async doGetOrganizations(params = {})
	{
		params['lang'] = this.getLang();
		
		try {
			const response = await axios.get('/api/organizations', {
				params,
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение данных о учебном заведении по его id
	 */
	async doGetOrganization(organization_id)
	{
		try {
			const response = await axios.get('/api/organizations/' + organization_id, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Добавление учебного заведения
	 */
	async doAddOrganization(params = {})
	{
		try {
			const response = await axios.post('/api/organizations', params, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Изменение данных учебного заведения по его id
	 */
	async doEditOrganization(organization_id, params = {})
	{
		try {
			const response = await axios.post('/api/organizations/' + organization_id, params, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление учебного заведения по его id
	 */
	async doDeleteOrganization(organization_id)
	{
		try {
			const response = await axios.delete('/api/organizations/' + organization_id, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка групп студентов
	 */
	async doGetStudentsGroups(params = {})
	{
		params['lang'] = this.getLang();
		
		try {
			const response = await axios.get('/api/students-groups', {
				params,
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка групп студентов по языку
	 */
	async doGetStudentsGroupsByLang(lang, params = {})
	{
		params['lang'] = this.getLang();
		
		try {
			const response = await axios.get('/api/students-groups-by-lang/' + lang, {
				params,
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение данных о группе студентов по ее id
	 */
	async doGetStudentsGroup(group_id)
	{
		try {
			const response = await axios.get('/api/students-groups/' + group_id, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Добавление группы студентов
	 */
	async doAddStudentsGroup(params = {})
	{
		try {
			const response = await axios.post('/api/students-groups', params, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Изменение данных группы студентов по ее id
	 */
	async doEditStudentsGroup(group_id, params = {})
	{
		try {
			const response = await axios.post('/api/students-groups/' + group_id, params, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление группы студентов по ее id
	 */
	async doDeleteStudentsGroup(group_id)
	{
		try {
			const response = await axios.delete('/api/students-groups/' + group_id, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка студентов
	 */
	async doGetStudents(group_id, params = {})
	{
		params['lang'] = this.getLang();
		
		try {
			const response = await axios.get('/api/students-groups/' + group_id + '/students', {
				params,
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка студентов не добавленных в экзамен
	 */
	async doGetStudentsWithoutExam(group_id, exam_id, params = {})
	{
		params['lang'] = this.getLang();
		
		try {
			const response = await axios.get('/api/students-groups/' + group_id + '/students-without-exam/' + exam_id, {
				params,
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение данных о студенте по его id
	 */
	async doGetStudent(group_id, student_id)
	{
		try {
			const response = await axios.get('/api/students-groups/' + group_id + '/students/' + student_id, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Добавление студента
	 */
	async doAddStudent(group_id, params = {})
	{
		try {
			const response = await axios.post('/api/students-groups/' + group_id + '/students', params, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Изменение данных студента по его id
	 */
	async doEditStudent(group_id, student_id, params = {})
	{
		try {
			const response = await axios.post('/api/students-groups/' + group_id + '/students/' + student_id, params, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление студента по его id
	 */
	async doDeleteStudent(group_id, student_id)
	{
		try {
			const response = await axios.delete('/api/students-groups/' + group_id + '/students/' + student_id, {
				params: {
					lang: this.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
}
